import React from "react";

import { LookupActionsButton } from "../../../../../../../common/components/lookup-buttons/LookupActionsButton";
import { useAssociateLookupCloudAsset } from "../../../../../../common/content/buttons/lookups/lookup-cloud-asset/useAssociateLookupCloudAsset";
import { useAssociateLookupContent } from "../../../../../../common/content/buttons/lookups/lookup-content/useAssociateLookupContent";
import { useAssociateLookupHistory } from "../../../../../../common/content/buttons/lookups/lookup-history/useAssociateLookupHistory";
import { AssociateActions } from "../../../../../../common/content/types/AssociateActions";

export type AssociateLookupActionsButtonProps = {
    actions: AssociateActions;
};

export const CloudFileLookupActionsButton = (): JSX.Element => {
    const { setContentFromLookupContent } = useAssociateLookupContent();
    const { setContentFromLookupHistory } = useAssociateLookupHistory();
    const { setContentFromLookupCloudAsset } = useAssociateLookupCloudAsset();

    return (
        <LookupActionsButton
            setContentFromLookupContent={setContentFromLookupContent}
            setContentFromLookupHistory={setContentFromLookupHistory}
            setContentFromLookupCloudAsset={setContentFromLookupCloudAsset}
        />
    );
};
